module.exports = "/images/visa.png?fdabc70aa6ab121bfac7b48af833183e";